import { render, staticRenderFns } from "./CartDiscount.vue?vue&type=template&id=0220ac15"
import script from "./CartDiscount.vue?vue&type=script&lang=ts"
export * from "./CartDiscount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports